import React from 'react';
import {Link} from 'react-router-dom';
import HubLogo from '../../../assests/img/hub-logo.png';

interface homeLogoProps {
    isLinkable?: boolean
}

function HomeLogo(props: homeLogoProps) {
    const {isLinkable} = props;

    const renderImg = () => {
        return (
            <img src={HubLogo} alt="client-logo" height="40px"/>
        );
    };

    const renderContent = () => {
        return (
            isLinkable ?
            <Link to='/'>{renderImg()}</Link>:
            renderImg()
        )
    };

    return renderContent();
}

export default HomeLogo;
